"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumMapper = void 0;
const enums_1 = require("../../enums");
class EnumMapper {
    static mapEnumsRecursively(object) {
        const isArray = Array.isArray(object);
        let mappedObject = isArray ? [...object] : Object.assign({}, object);
        if (isArray) {
            mappedObject = mappedObject.map((innerObject) => this.mapEnumsRecursively(innerObject));
        }
        else if (typeof mappedObject === 'object') {
            mappedObject = this.mapEnums(mappedObject);
            Object.keys(mappedObject).forEach((key) => {
                if (Array.isArray(mappedObject[key])) {
                    mappedObject[key] = mappedObject[key].map((innerObject) => this.mapEnumsRecursively(innerObject));
                }
                else if (typeof mappedObject[key] === 'object' && mappedObject[key] !== null) {
                    mappedObject[key] = this.mapEnumsRecursively(mappedObject[key]);
                }
            });
        }
        return mappedObject;
    }
    static mapEnums(object) {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, object), this.mapCustomerTypeEnums(object)), this.mapFinanceProviderEnums(object)), this.mapFinancingTypeEnums(object)), this.mapOrderStatusEnums(object)), this.mapOrderEventTypeEnums(object)), this.mapInsuranceTypeEnums(object)), this.mapAccessoryTypeEnums(object)), this.mapVehicleReserveStatusEnums(object));
    }
    static mapFinanceProviderEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('financeProvider'))
            ? typeof object.financeProvider === 'string'
                ? { financeProvider: enums_1.FinanceProvider[object.financeProvider] }
                : { financeProvider: object.financeProvider }
            : {};
    }
    static mapFinancingTypeEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('financingType'))
            ? typeof object.financingType === 'string'
                ? { financingType: enums_1.FinancingType[object.financingType] }
                : { financingType: object.financingType }
            : {};
    }
    static mapCustomerTypeEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('customerType'))
            ? typeof object.customerType === 'string'
                ? { customerType: enums_1.CustomerType[object.customerType] }
                : { customerType: object.customerType }
            : {};
    }
    static mapOrderEventTypeEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('eventType'))
            ? typeof object.eventType === 'string' && Object.keys(enums_1.OrderEventType).indexOf(object.eventType) > -1
                ? { eventType: enums_1.OrderEventType[object.eventType] }
                : { eventType: object.eventType }
            : {};
    }
    static mapOrderStatusEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('status'))
            ? typeof object.status === 'string' && Object.keys(enums_1.OrderStatus).indexOf(object.status) > -1
                ? { status: enums_1.OrderStatus[object.status] }
                : { status: object.status }
            : {};
    }
    static mapVehicleReserveStatusEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('vehicleReserveStatus'))
            ? typeof object.vehicleReserveStatus === 'string' &&
                Object.keys(enums_1.VehicleReserveStatus).indexOf(object.vehicleReserveStatus) > -1
                ? { vehicleReserveStatus: enums_1.VehicleReserveStatus[object.vehicleReserveStatus] }
                : { vehicleReserveStatus: object.vehicleReserveStatus }
            : {};
    }
    static mapInsuranceTypeEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('insuranceType'))
            ? typeof object.insuranceType === 'string' && Object.keys(enums_1.InsuranceType).indexOf(object.insuranceType) > -1
                ? { insuranceType: enums_1.InsuranceType[object.insuranceType] }
                : { insuranceType: object.insuranceType }
            : {};
    }
    static mapAccessoryTypeEnums(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('accessoryType'))
            ? typeof object.accessoryType === 'string' && Object.keys(enums_1.AccessoryType).indexOf(object.accessoryType) > -1
                ? { accessoryType: enums_1.AccessoryType[object.accessoryType] }
                : { accessoryType: object.accessoryType }
            : {};
    }
    static mapEnumsToStringRecursively(object) {
        const isArray = Array.isArray(object);
        let mappedObject = isArray ? [...object] : Object.assign({}, object);
        if (isArray) {
            mappedObject = mappedObject.map((innerObject) => this.mapEnumsToStringRecursively(innerObject));
        }
        else if (typeof mappedObject === 'object') {
            mappedObject = this.mapEnumsToString(mappedObject);
            Object.keys(mappedObject).forEach((key) => {
                if (Array.isArray(mappedObject[key])) {
                    mappedObject[key] = mappedObject[key].map((innerObject) => this.mapEnumsToStringRecursively(innerObject));
                }
                else if (typeof mappedObject[key] === 'object' && mappedObject[key] !== null) {
                    mappedObject[key] = this.mapEnumsToStringRecursively(mappedObject[key]);
                }
            });
        }
        return mappedObject;
    }
    static mapEnumsToString(object) {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, object), this.mapCustomerTypeEnumsToString(object)), this.mapFinanceProviderEnumsToString(object)), this.mapFinancingTypeEnumsToString(object)), this.mapOrderStatusEnumsToString(object)), this.mapOrderEventTypeEnumsToString(object)), this.mapInsuranceEnumsToString(object)), this.mapAccessoryTypeEnumsToString(object)), this.mapVehicleReserveStatusEnumsToString(object));
    }
    static mapFinanceProviderEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('financeProvider'))
            ? typeof object.financeProvider === 'string'
                ? { financeProvider: object.financeProvider }
                : { financeProvider: enums_1.FinanceProvider[object.financeProvider] }
            : {};
    }
    static mapFinancingTypeEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('financingType'))
            ? typeof object.financingType === 'string'
                ? { financingType: object.financingType }
                : { financingType: enums_1.FinancingType[object.financingType] }
            : {};
    }
    static mapCustomerTypeEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('customerType'))
            ? typeof object.customerType === 'string'
                ? { customerType: object.customerType }
                : { customerType: enums_1.CustomerType[object.customerType] }
            : {};
    }
    static mapOrderStatusEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('status'))
            ? typeof object.status === 'number' && Object.keys(enums_1.OrderStatus).indexOf(object.status.toString()) > -1
                ? { status: enums_1.OrderStatus[object.status] }
                : { status: object.status }
            : {};
    }
    static mapVehicleReserveStatusEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('vehicleReserveStatus'))
            ? typeof object.vehicleReserveStatus === 'number' &&
                Object.keys(enums_1.VehicleReserveStatus).indexOf(object.vehicleReserveStatus.toString()) > -1
                ? { vehicleReserveStatus: enums_1.VehicleReserveStatus[object.vehicleReserveStatus] }
                : { vehicleReserveStatus: object.vehicleReserveStatus }
            : {};
    }
    static mapOrderEventTypeEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('eventType'))
            ? typeof object.eventType === 'number' && Object.keys(enums_1.OrderEventType).indexOf(object.eventType.toString()) > -1
                ? { eventType: enums_1.OrderEventType[object.eventType] }
                : { eventType: object.eventType }
            : {};
    }
    static mapInsuranceEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('insuranceType'))
            ? typeof object.insuranceType === 'number' &&
                Object.keys(enums_1.InsuranceType).indexOf(object.insuranceType.toString()) > -1
                ? { insuranceType: enums_1.InsuranceType[object.insuranceType] }
                : { insuranceType: object.insuranceType }
            : {};
    }
    static mapAccessoryTypeEnumsToString(object) {
        return (object === null || object === void 0 ? void 0 : object.hasOwnProperty('accessoryType'))
            ? typeof object.accessoryType === 'number' &&
                Object.keys(enums_1.AccessoryType).indexOf(object.accessoryType.toString()) > -1
                ? { accessoryType: enums_1.AccessoryType[object.accessoryType] }
                : { accessoryType: object.accessoryType }
            : {};
    }
}
exports.EnumMapper = EnumMapper;
//# sourceMappingURL=enums.js.map